import EditableBox from './EditableBox';

export default EditableBox;
